import * as React from "react";
import {
  Button,
  // Container,
  Dropdown,
  Form,
  Modal,
  Col,
  Row,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import ReactTooltip from "react-tooltip";
import { FiChevronDown } from "react-icons/fi";
import { toast, ToastContainer } from "react-toastify";
import { MyImage } from "../../Common/Components/MyImage";
import { ModuleReports } from "../../Common/Services/ModuleReports";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import reportPreview from "../../Common/Assets/Images/report_thumb.png";
import { MultiSelectReportTags } from "../../Common/Components/MultiSelectReportTags";
// import { debug } from "console";
import { resolve, reject } from "q";
import { ReactPageLoader } from "../../Common/Components/ReactPageLoader";
import { Utils } from "../../Common/Utilis";

const tooltipMessageAdd = "Add to My Reports";

let reportTagList = [] as any;
export class ReportGallery extends React.Component<any, any> {
  private multiselectChild: any;
  constructor(props: any) {
    super(props);
    this.multiselectChild = React.createRef();
    this.state = {
      loaderTrue: false,
      search: "",
      showMediaViewer: false,
      reportType: "Report Type",
      hideModal: false,
      newReportName: "",
      mediaViewerTitle: "",
      showRenameModal: false,
      selectedTags: [] as any,
      reportData: [] as any,
      filteredData: [] as any,
      breadCrumps: [] as any,
      reportPermissions: [] as any,
      userReports: [] as any,
      parentReportId: 0,
      showBackbtn: false,
      disableSave: false,
      showVarient: true,
      isVarientExpanded: false,
      ispermissionloaded: false,
      sortingOrder: "Alphabetical",
      reportpreviewUrl: 0,
      reportImages: [],
      currentImage: {} as any,
    };
    this.hideRenameModal = this.hideRenameModal.bind(this);
    this.saveReport = this.saveReport.bind(this);
    this.hidegalleryModal = this.hidegalleryModal.bind(this);
  }

  componentDidMount() {
    this.getUserReport();
    this.getIsModForReport();
    this.getReportPermissions();
  }

  getReportPermissions = () => {
    let requestObject = {} as any;
    this.setState({ loaderTrue: true });
    ModuleReports.GetReportPermissionData(requestObject)
      .then(async (result: any | null) => {
        if (result != null && result.length > 0) {
          this.setState(
            { reportPermissions: result, ispermissionloaded: true },
            () => {
              this.getModuleReports();
            }
          );
        }
        resolve();
      })
      .catch((err: any) => {
        Utils.toastError(`Server Error, ${err}`, {
          position: toast.POSITION.BOTTOM_RIGHT,
          // // containerId: "reportGallerySelection",
        });
        this.setState({ loaderTrue: false });
        reject();
      });
  };

  getIsModForReport() {
    // New Implimatio by AJay
    ModuleReports.getIsMOde().then((resultt: any) => {
      if (resultt != null) {
        this.setState({ isModeData: resultt });
      }
    });
  }

  getModuleReports() {
    ModuleReports.getModuleReports(4)
      .then((result: any) => {
        this.setState({ loaderTrue: false });
        if (result != null) {
          const data = result.result;
         
          let allowedReports = [] as any;
          let Module_Id = ModuleReports.getModuleId(localStorage.mainMenu as any);
          data.forEach((report: any) => {
            if (report.parentId > 0) {
              let parentReport = data.filter(
                (x) => x.moduleReportId === report.parentId
              );
              if (parentReport.length > 0) {
                let hasPermission = this.state.reportPermissions.filter(
                  (x) =>
                    x.permissionName.toLowerCase() ===
                    parentReport[0].reportName.toLowerCase()
                );
                if (hasPermission && hasPermission.length > 0) {
                  allowedReports.push(report);
                }
              }
            } else {
              if (Module_Id === 20) {
                allowedReports.push(report);
              } else {

                let hasPermission = this.state.reportPermissions.filter(
                  (x) =>
                    x.permissionName.toLowerCase() ===
                    report.reportName.toLowerCase()
                );
                if (hasPermission && hasPermission.length > 0) {
                  allowedReports.push(report);
                }
              }
            }
          });
          allowedReports.sort((a, b) =>
            a["reportName"].localeCompare(b["reportName"])
          );
          this.setState({
            AllReportData: allowedReports,
            reportData: allowedReports.filter((x) => x.parentId === 0),
            filteredData: allowedReports.filter((x) => x.parentId === 0),
          });
        }
      })
      .catch((error) => {
        // Need to handle this
        console.log(error);
      });
  }

  getUserReport = () => {
    ModuleReports.GetUserReport()
      .then((result: any[]) => {
        if (result != null && result.length > 0) {
          const data = result;
          this.setState({ userReports: data });
        } else {
          this.setState({ userReports: [] });
        }
      })
      .catch((error) => {
        // Need to handle this
        this.setState({ userReports: [] });
      });
  };

  searchReport = (e) => {
    this.setState({ search: e.target.value }, () => this.filterData());
  };

  filterReports = (item) => {
    this.setState({ reportType: item.name });
  };

  sortReports = (sortBy) => {
    let sortReports = [...this.state.filteredData];
    const data = sortReports;
    if (sortBy === "Alphabetical") {
      data.sort((a, b) => a["reportName"].localeCompare(b["reportName"]));
      this.setState({ filteredData: data });
    }
  };

  openReportViewer = (e, item) => {
    // debugger;
    this.props.onShowReport(e, item, "gallery");
    // if(item.reportName="Department Permission Report")
    // {
    //   this.props.logReportLoadTiming('onstart')
    // }
  };

  getVarientCount = (moduleReportId) => {
    if (moduleReportId === 2023) {
      if (this.state.isModeData[0].countMod === 0) {
        let varients = this.state.AllReportData.filter(
          (x) => x.parentId === moduleReportId && x.moduleReportId != "2029"
        );
        return varients?.length;
      } else {
        let varients = this.state.AllReportData.filter(
          (x) => x.parentId === moduleReportId
        );
        return varients?.length;
      }
    } else {
      let varients = this.state.AllReportData.filter(
        (x) => x.parentId === moduleReportId
      );
      return varients?.length;
    }
  };

  getReportVarients = (parentReportId, reportName) => {
    let reports = [] as any;
    let breadCrumps = this.state.breadCrumps;
    breadCrumps.push({ parentReportId, reportName });
    this.setState(
      { parentReportId, breadCrumps, isVarientExpanded: true },
      () => {
        if (parentReportId === 2023) {
          if (this.state.isModeData[0].countMod === 0) {
            reports = this.state.AllReportData.filter(
              (x) =>
                x.parentId === this.state.parentReportId &&
                x.moduleReportId != "2029"
            );
            this.setState({ filteredData: reports });
          } else {
            reports = this.state.AllReportData.filter(
              (x) => x.parentId === this.state.parentReportId
            );
            this.setState({ filteredData: reports });
          }
        } else {
          reports = this.state.AllReportData.filter(
            (x) => x.parentId === this.state.parentReportId
          );
          this.setState({ filteredData: reports });
        }
      }
    );
  };

  backtoParentReports = (report) => {
    if (report.parentReportId === 0) {
      this.setState({ breadCrumps: [], isVarientExpanded: false });
    }
    this.setState({ parentReportId: report.parentReportId }, () => {
      this.filterData();
    });
  };

  openSaveReportModal = (report) => {
    let reportExist = this.state.userReports.filter(
      (x) => x.reportName.toLowerCase() === report.reportName.toLowerCase()
    );
    this.setState({
      reportToSave: report,
      showRenameModal: true,
      newReportName:
        reportExist && reportExist.length > 0
          ? report.reportName
          : "Copy Of " + report.reportName,
    });
  };

  saveReport = async () => {
    if (this.state.newReportName.trim().length === 0) {
      Utils.toastError("Please enter Report Name.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "reportGallerySelection",
      });
      return false;
    }
    const request: any = {};
    request.ReportName = this.state.newReportName;
    request.ReportType = this.state.reportToSave.reportName;
    request.ReportId = this.state.reportToSave.moduleReportId;
    request.UserReportId = 0;
    request.ReportParameter = "";
    this.setState({ disableSave: true });
    try {
      const result: any = await ModuleReports.SaveUserReport(request);
      this.setState({ disableSave: false });
      if (result.success) {
        this.getUserReport();
        this.setState({ showRenameModal: false, newReportName: "" });
        toast.success(result.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          // // containerId: "reportGallerySelection",
        });
      } else {
        Utils.toastError(result.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          // // containerId: "reportGallerySelection",
        });
      }
    } catch (error) {
      this.setState({ disableSave: false });
      Utils.toastError("Something went wrong", {
        position: toast.POSITION.BOTTOM_RIGHT,
        // // containerId: "reportGallerySelection",
      });
    }
  };

  hideRenameModal = () => {
    this.setState({ showRenameModal: false });
  };

  changeReportName = (e) => {
    this.setState({ newReportName: e.target.value });
  };

  getAllReportTags(reportTag) {
    let tagArr = [] as any;
    if (reportTag) {
      tagArr = reportTag.split(",");
    }

    let messageArr = [] as any;
    messageArr = [...tagArr];
    if (messageArr.length > 0) {
      messageArr.splice(0, 1);
    }
    if (messageArr.length > 0) {
      messageArr.splice(0, 1);
    }
    const tooltipMessage = messageArr.join(", ");
    if (tagArr.length > 2) {
      return (
        <div className="report-tag rm-bg">
          <button type="button" className="showalltags d-flex">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M7.9999 2.3999C7.59665 2.3999 7.26947 2.72709 7.26947 3.13034V7.26947H3.13034C2.72709 7.26947 2.3999 7.59665 2.3999 7.9999C2.3999 8.40315 2.72709 8.73034 3.13034 8.73034H7.26947V12.8695C7.26947 13.2727 7.59665 13.5999 7.9999 13.5999C8.40315 13.5999 8.73034 13.2727 8.73034 12.8695V8.73034H12.8695C13.2727 8.73034 13.5999 8.40315 13.5999 7.9999C13.5999 7.59665 13.2727 7.26947 12.8695 7.26947H8.73034V3.13034C8.73034 2.72709 8.40315 2.3999 7.9999 2.3999Z" />
            </svg>
            {tagArr.length <= 2 ? (
              ""
            ) : (
              <div style={{ marginTop: "1px", paddingRight: "2px" }}>
                {" "}
                {tagArr.length - 2} More
              </div>
            )}
            <div className="tooltip bs-tooltip-top tooltip-custom">
              <div className="arrow"></div>
              <div className="tooltip-inner">{tooltipMessage}</div>
            </div>
          </button>
          {/* <ReactTooltip
            effect="solid"
            event="mouseover mouseenter"
            eventOff="mouseleave mouseout scroll mousewheel blur"
            place="bottom"
            multiline={true}
          />
          <button type="button" className="showalltags d-flex">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M7.9999 2.3999C7.59665 2.3999 7.26947 2.72709 7.26947 3.13034V7.26947H3.13034C2.72709 7.26947 2.3999 7.59665 2.3999 7.9999C2.3999 8.40315 2.72709 8.73034 3.13034 8.73034H7.26947V12.8695C7.26947 13.2727 7.59665 13.5999 7.9999 13.5999C8.40315 13.5999 8.73034 13.2727 8.73034 12.8695V8.73034H12.8695C13.2727 8.73034 13.5999 8.40315 13.5999 7.9999C13.5999 7.59665 13.2727 7.26947 12.8695 7.26947H8.73034V3.13034C8.73034 2.72709 8.40315 2.3999 7.9999 2.3999Z" />
            </svg>
            {tagArr.length <= 2 ? "" : <div style={{marginTop:'1px', paddingRight: '2px'}}> {tagArr.length - 2} More</div>}
          </button> */}
        </div>
      );
    }
  }
  getReportTags(reportTag) {
    let tagArr = [] as any;
    if (reportTag) {
      tagArr = reportTag.split(",");
    }
    let tags = [] as any;
    tagArr.map((tag, index) => {
      if (reportTagList.filter((x) => x.value === tag).length === 0) {
        let newItem = {} as any;
        newItem.tagId = index;
        newItem.value = tag;
        newItem.description = tag;
        newItem.isChecked = false;
        reportTagList.push(newItem);
      }
      if (tags.length <= 1) {
        tags.push(
          <div key={tag} className="report-tag">
            <EllipsisWithTooltip placement="bottom">{tag}</EllipsisWithTooltip>
          </div>
        );
      }
    });
    return tags;
  }
  updateMultiSelectItem = (selectedItem: any) => {
    this.setState({ selectedTags: selectedItem }, () => this.filterData());
  };
  dataChange = () => {
    this.setState({ isUnsavedChanges: true });
  };

  checkSelectedTag(reportTag) {
    let tags = [] as any;
    tags = reportTag.split(",");
    let selectedIteams = [...this.state.selectedTags];
    let filteredArray = selectedIteams.filter(function (itm) {
      return tags.indexOf(itm.value) > -1;
    });
    return filteredArray ? (filteredArray.length > 0 ? true : false) : false;
  }

  hasChildReport(report) {
    let ChildReports = this.state.reportData.filter((x) => x.parentId > 0);
    let filteredArray = ChildReports.filter(
      (x) => x.parentId === report.moduleReportId
    );
    return filteredArray ? (filteredArray.length > 0 ? true : false) : false;
  }

  hideShowVarient = (e) => {
    this.setState(
      {
        showVarient: !this.state.showVarient,
        parentReportId: 0,
        breadCrumps: [],
        isVarientExpanded: false,
      },
      () => {
        this.filterData();
      }
    );
  };
  openMediaViewer = (item) => {
    this.setState({
      showMediaViewer: true,
      mediaViewerTitle: item.reportName,
      reportpreviewUrl: item.reportImages[0]?.id,
      currentImage: item.reportImages[0],
      reportImages: item.reportImages,
    });
  };
  hideMediaViewerModal = () => {
    this.setState({ showMediaViewer: false });
  };

  filterData = () => {
    let reports = [] as any;
    if (this.state.reportData.length > 0) {
      if (this.state.showVarient === true) {
        if (this.state.isVarientExpanded) {
          reports = this.state.AllReportData.filter(
            (x) => x.parentId === this.state.parentReportId
          );
        } else {
          reports = this.state.reportData;
        }
      } else {
        reports = this.state.AllReportData.filter(
          (x) => !this.hasChildReport(x)
        );
      }
    }

    if (this.state.selectedTags.length > 0) {
      if (this.state.parentReportId > 0) {
        reports = reports.filter(
          (x) => x.parentId === this.state.parentReportId
        );
      }
      reports = reports.filter((x) => {
        return this.checkSelectedTag(x.reportTag);
      });
    }

    if (this.state.search !== "") {
      reports = reports.filter(
        (x) =>
          x.reportName
            ?.toLowerCase()
            .includes(this.state.search.toLowerCase()) ||
          x.reportTag?.toLowerCase().includes(this.state.search.toLowerCase())
      );
    }

    this.setState({ filteredData: reports });
  };

  hidegalleryModal = () => {
    this.multiselectChild.current.handleClearAll(null);
    this.props.hideReportGalleryModal();
  };

  render() {
    const { filteredData } = this.state;

    let ModuleName = "Labor Report Gallery";
    let str = window.location.href;
    if (str.includes("Account-management")) {
      ModuleName = "Accounting Report Gallery";
    } else if (str.includes("labor-management")) {
      ModuleName = "Labor Report Gallery";
    }else if (str.includes("facilities-management")) {
      ModuleName = "Facilities Report Gallery";
    }

    // let Reports = [] as any;
    // if (this.state.reportData.length > 0) {
    //   if (this.state.showVarient === true) {
    //     Reports = this.state.reportData.filter(
    //       (x) => x.parentId === this.state.parentReportId
    //     );
    //   } else {
    //     Reports = this.state.reportData.filter((x) => !this.hasChildReport(x));
    //   }
    // }

    // if (this.state.selectedTags.length > 0) {
    //   Reports = this.state.reportData.filter((x) => {
    //     return this.checkSelectedTag(x.reportTag);
    //   });
    // }

    // if (this.state.search !== "") {
    //   Reports = Reports.filter(
    //     (x) =>
    //       x.reportName
    //         ?.toLowerCase()
    //         .includes(this.state.search.toLowerCase()) ||
    //       x.reportTag?.toLowerCase().includes(this.state.search.toLowerCase())
    //   );
    // }

    // if (!(this.state.search == "" && this.state.selectedTags.length === 0)) {
    //   Reports = this.state.reportData.filter((x) => {
    //     return (
    //       x.reportName
    //         ?.toLowerCase()
    //         .includes(this.state.search.toLowerCase()) &&
    //       this.checkSelectedTag(x.reportTag)
    //     );
    //   });
    // }

    return (
      <>
        <Modal
          show={this.props.showModal}
          keyboard={false}
          onHide={this.hidegalleryModal}
          className={`reports-display-modal ${this.state.showRenameModal ? "report-gallary-z-index" : ""
            }`}
        >
          <Modal.Header closeButton>
            <Modal.Title className="mr-auto">{ModuleName}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="main-Page reports-container">
              <div className="navigation-bar">
                <div className="navigation-menus d-flex">
                  <div className="schedule-table-search">
                    <input
                      type="text"
                      className="form-control "
                      placeholder="Search..."
                      value={this.state.search}
                      onChange={(e) => this.searchReport(e)}
                    />
                  </div>

                  <div className="report-type-dropdown ml-2 mr-2">
                    <MultiSelectReportTags
                      ref={this.multiselectChild}
                      itemList={reportTagList}
                      updateMultiSelectItem={this.updateMultiSelectItem.bind(
                        this
                      )}
                      dataChange={this.dataChange.bind(this)}
                      isSelectAll={true}
                      filtertitle={"Filter By Tags"}
                    />
                  </div>

                  <div className="navigationSort ml-auto">
                    {/* <Dropdown className="more-action bg-blue" alignRight>
                      <Dropdown.Toggle className="" id="dropdown-more">
                        <div className="d-flex align-items-center">
                          <svg
                            width="16"
                            height="12"
                            viewBox="0 0 16 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M3.5 12L6.5 9H4.25V0H2.75V9H0.5L3.5 12ZM7.25 3H14V4.5H7.25V3ZM7.25 6H12.5V7.5H7.25V6ZM7.25 0H15.5V1.5H7.25V0ZM7.25 9H11V10.5H7.25V9Z" />
                          </svg>
                          Alphabetical
                          <div className="drop-arrow d-flex">
                            <FiChevronDown />
                          </div>
                        </div>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Header>SORT</Dropdown.Header>
                        <Dropdown.Item
                          className={
                            this.state.sortingOrder === "Alphabetical"
                              ? "active"
                              : ""
                          }
                          onClick={(e: any) => this.sortReports("Alphabetical")}
                        >
                          <div className="d-flex">
                            <div className="mr-auto">Alphabetical</div>
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7.49998 11.6895L5.03023 9.21973L3.96973 10.2802L7.49998 13.8105L14.7802 6.53023L13.7197 5.46973L7.49998 11.6895Z"
                                fill="#2CAF92"
                              />
                            </svg>
                          </div>
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                    */}
                  </div>

                  <div className="navigationSettings">
                    <Dropdown className="more-action bg-blue" alignRight>
                      <Dropdown.Toggle className="" id="dropdown-more">
                        <div className="d-flex align-items-center">
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M0.562614 9.18059L1.89595 11.4873C2.07995 11.8059 2.48795 11.9153 2.80661 11.7306L3.73728 11.1933C4.12395 11.4979 4.55128 11.7479 5.00061 11.9346V12.9999C5.00061 13.3679 5.29861 13.6666 5.66728 13.6666H8.33395C8.70261 13.6666 9.00062 13.3679 9.00062 12.9999V11.9346C9.44995 11.7479 9.87661 11.4979 10.2639 11.1933L11.1946 11.7306C11.5126 11.9139 11.9219 11.8039 12.1053 11.4873L13.4386 9.18059C13.6219 8.86325 13.5119 8.45325 13.1953 8.26992L12.2806 7.74125C12.3153 7.49525 12.3333 7.24725 12.3333 6.99992C12.3333 6.75259 12.3153 6.50459 12.2793 6.25858L13.1939 5.72992C13.5113 5.54659 13.6213 5.13659 13.4373 4.81925L12.1039 2.51259C11.9199 2.19392 11.5119 2.08459 11.1933 2.26925L10.2626 2.80659C9.87595 2.50192 9.44928 2.25125 8.99995 2.06525V0.999919C8.99995 0.631919 8.70195 0.333252 8.33328 0.333252H5.66661C5.29795 0.333252 4.99995 0.631919 4.99995 0.999919V2.06525C4.55061 2.25192 4.12395 2.50192 3.73661 2.80659L2.80661 2.26925C2.48728 2.08459 2.07995 2.19392 1.89595 2.51259L0.562614 4.81925C0.379281 5.13659 0.489281 5.54659 0.805948 5.72992L1.72061 6.25858C1.68461 6.50459 1.66661 6.75259 1.66661 6.99992C1.66661 7.24725 1.68461 7.49525 1.72061 7.74125L0.805948 8.26992C0.488614 8.45325 0.378614 8.86325 0.562614 9.18059ZM6.99995 4.33325C8.47061 4.33325 9.66661 5.52925 9.66661 6.99992C9.66661 8.47059 8.47061 9.66659 6.99995 9.66659C5.52928 9.66659 4.33328 8.47059 4.33328 6.99992C4.33328 5.52925 5.52928 4.33325 6.99995 4.33325Z" />
                          </svg>
                          <div className="drop-arrow ml-0 d-flex">
                            <FiChevronDown />
                          </div>
                        </div>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <div className="variance-modal">
                          <div className="bdy-container">
                            <div className="ttl">Enable/Disable Versions</div>
                            <Form.Group as={Row} controlId="">
                              <Form.Label column sm="8">
                                Group Versions
                              </Form.Label>
                              <Col sm="4">
                                <Form.Check
                                  type="switch"
                                  className="sm-controll"
                                  id="custom-switch2"
                                  label=""
                                  checked={this.state.showVarient}
                                  onChange={(e: any) => this.hideShowVarient(e)}
                                />
                              </Col>
                            </Form.Group>
                          </div>
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>

              {this.state.loaderTrue ? (
                <ReactPageLoader useas={"reportsGallery"} />
              ) : (
                <>
                  <div className="reports-blockwise">
                    {this.state.breadCrumps.length > 0 && (
                      <>
                        <div className="report-variant-breadcrumbs d-flex align-items-center">
                          {this.state.showVarient && (
                            <Button
                              className="reset-password-btn btn-ghost"
                              onClick={(e) =>
                                this.backtoParentReports({ parentReportId: 0 })
                              }
                            >
                              &laquo; Back
                            </Button>
                          )}
                          {/* {this.state.breadCrumps.map((report) => (
                        <div className="variant-breadcrumbs-report-name">
                          <Button
                            className="reset-password-btn btn-ghost"
                            onClick={(e) => this.backtoParentReports(report)}
                          >
                            {report.reportName}

                          </Button>{" "}
                          {">"}
                        </div>
                      ))} */}
                        </div>
                      </>
                    )}
                    <ul>
                      {filteredData.length === 0 && (
                        <div className="blank-data-screen">
                          <span className="icon d-block">
                            <svg
                              width="128"
                              height="128"
                              viewBox="0 0 128 128"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle cx="64" cy="64" r="64" fill="#DEFFF8" />
                              <path
                                d="M94.6226 70.3666V48.5778C98.3859 48.0355 101.289 44.7989 101.289 40.8889C101.289 36.6011 97.8004 33.1111 93.5115 33.1111C89.2226 33.1111 85.7337 36.6011 85.7337 40.8889H32.4004V85.3333H65.7904C66.3682 94.6177 74.0848 102 83.5115 102C93.3137 102 101.289 94.0244 101.289 84.2222C101.289 78.6233 98.6815 73.6277 94.6226 70.3666ZM93.5115 35.3333C96.5748 35.3333 99.0671 37.8255 99.0671 40.8889C99.0671 43.9522 96.5748 46.4444 93.5115 46.4444C90.4482 46.4444 87.9559 43.9522 87.9559 40.8889C87.9559 37.8255 90.4482 35.3333 93.5115 35.3333ZM34.6226 43.1111H86.0615C86.3271 43.9978 86.7493 44.8144 87.2915 45.5389L80.4959 52.3344C80.0604 52.1255 79.5804 52 79.0671 52C78.5537 52 78.0737 52.1255 77.6393 52.3344L75.4004 50.0955C75.6082 49.66 75.7337 49.18 75.7337 48.6666C75.7337 46.8289 74.2382 45.3333 72.4004 45.3333C70.5626 45.3333 69.0671 46.8289 69.0671 48.6666C69.0671 49.18 69.1926 49.66 69.4015 50.0944L63.8293 55.6666C63.3937 55.4589 62.9137 55.3333 62.4004 55.3333C60.5626 55.3333 59.0671 56.8289 59.0671 58.6666C59.0671 60.5044 60.5626 62 62.4004 62C64.2382 62 65.7337 60.5044 65.7337 58.6666C65.7337 58.1533 65.6082 57.6733 65.3993 57.2389L70.9715 51.6666C71.4071 51.8744 71.8871 52 72.4004 52C72.9137 52 73.3937 51.8744 73.8282 51.6655L76.0671 53.9044C75.8593 54.34 75.7337 54.82 75.7337 55.3333C75.7337 57.1711 77.2293 58.6666 79.0671 58.6666C80.9048 58.6666 82.4004 57.1711 82.4004 55.3333C82.4004 54.82 82.2748 54.34 82.0659 53.9055L88.8626 47.11C89.8793 47.8722 91.0859 48.3889 92.4004 48.5789V68.8511C89.7815 67.33 86.7515 66.4444 83.5115 66.4444C78.2004 66.4444 73.4382 68.7977 70.1782 72.5033V67.5555H63.5115V80.8889H66.0582C65.9204 81.6144 65.8371 82.3577 65.7904 83.1111H34.6226V43.1111ZM79.0671 54.2222C79.6793 54.2222 80.1782 54.72 80.1782 55.3333C80.1782 55.9466 79.6793 56.4444 79.0671 56.4444C78.4548 56.4444 77.9559 55.9466 77.9559 55.3333C77.9559 54.72 78.4548 54.2222 79.0671 54.2222ZM71.2893 48.6666C71.2893 48.0533 71.7882 47.5555 72.4004 47.5555C73.0126 47.5555 73.5115 48.0533 73.5115 48.6666C73.5115 49.28 73.0126 49.7778 72.4004 49.7778C71.7882 49.7778 71.2893 49.28 71.2893 48.6666ZM63.5115 58.6666C63.5115 59.28 63.0126 59.7777 62.4004 59.7777C61.7882 59.7777 61.2893 59.28 61.2893 58.6666C61.2893 58.0533 61.7882 57.5555 62.4004 57.5555C63.0126 57.5555 63.5115 58.0533 63.5115 58.6666ZM83.5115 93.1111C78.6104 93.1111 74.6226 89.1233 74.6226 84.2222C74.6226 79.3211 78.6104 75.3333 83.5115 75.3333C88.4126 75.3333 92.4004 79.3211 92.4004 84.2222C92.4004 89.1233 88.4126 93.1111 83.5115 93.1111ZM67.9559 75.6344C67.4237 76.5944 66.9837 77.6089 66.6348 78.6666H65.7337V69.7777H67.9559V75.6344ZM82.4004 68.7233V73.1677C76.7937 73.7277 72.4004 78.4711 72.4004 84.2222C72.4004 85.8477 72.7604 87.3889 73.3904 88.7822L69.5359 91.0077C68.5337 88.9544 67.9559 86.6566 67.9559 84.2222C67.9559 76.02 74.3415 69.2966 82.4004 68.7233ZM83.5115 99.7777C78.1626 99.7777 73.4359 97.0633 70.6359 92.9389L74.5059 90.7044C76.5259 93.5022 79.8048 95.3333 83.5115 95.3333C87.2182 95.3333 90.4971 93.5022 92.5171 90.7044L96.3871 92.9389C93.5871 97.0633 88.8604 99.7777 83.5115 99.7777ZM97.4871 91.0077L93.6326 88.7822C94.2626 87.3889 94.6226 85.8477 94.6226 84.2222C94.6226 78.4711 90.2293 73.7266 84.6226 73.1677V68.7233C92.6815 69.2966 99.0671 76.02 99.0671 84.2222C99.0671 86.6566 98.4893 88.9544 97.4871 91.0077Z"
                                fill="#1ACAA3"
                              />
                              <path
                                d="M83.5114 77.5555C79.8347 77.5555 76.8447 80.5455 76.8447 84.2222C76.8447 87.8989 79.8347 90.8889 83.5114 90.8889C87.1881 90.8889 90.1781 87.8989 90.1781 84.2222C90.1781 80.5455 87.1881 77.5555 83.5114 77.5555ZM83.5114 88.6667C81.0603 88.6667 79.0669 86.6733 79.0669 84.2222C79.0669 81.7711 81.0603 79.7778 83.5114 79.7778C85.9625 79.7778 87.9558 81.7711 87.9558 84.2222C87.9558 86.6733 85.9625 88.6667 83.5114 88.6667Z"
                                fill="#1ACAA3"
                              />
                              <path
                                d="M36.8447 45.3333H39.0669V47.5555H36.8447V45.3333Z"
                                fill="#1ACAA3"
                              />
                              <path
                                d="M41.2891 45.3333H56.8446V47.5555H41.2891V45.3333Z"
                                fill="#1ACAA3"
                              />
                              <path
                                d="M36.8447 49.7778H39.0669V52H36.8447V49.7778Z"
                                fill="#1ACAA3"
                              />
                              <path
                                d="M41.2891 49.7778H56.8446V52H41.2891V49.7778Z"
                                fill="#1ACAA3"
                              />
                              <path
                                d="M36.8447 54.2222H39.0669V56.4444H36.8447V54.2222Z"
                                fill="#1ACAA3"
                              />
                              <path
                                d="M41.2891 54.2222H56.8446V56.4444H41.2891V54.2222Z"
                                fill="#1ACAA3"
                              />
                              <path
                                d="M36.8447 58.6666H39.0669V60.8888H36.8447V58.6666Z"
                                fill="#1ACAA3"
                              />
                              <path
                                d="M41.2891 58.6666H56.8446V60.8888H41.2891V58.6666Z"
                                fill="#1ACAA3"
                              />
                              <path
                                d="M36.8447 80.8889H43.5114V69.7778H36.8447V80.8889ZM39.0669 72H41.2892V78.6667H39.0669V72Z"
                                fill="#1ACAA3"
                              />
                              <path
                                d="M45.7334 80.8889H52.4001V72H45.7334V80.8889ZM47.9556 74.2222H50.1778V78.6667H47.9556V74.2222Z"
                                fill="#1ACAA3"
                              />
                              <path
                                d="M54.623 80.8889H61.2897V63.1111H54.623V80.8889ZM56.8453 65.3333H59.0675V78.6666H56.8453V65.3333Z"
                                fill="#1ACAA3"
                              />
                            </svg>
                          </span>
                          <span className="content d-block">
                            {filteredData?.length === 0 &&
                              (this.state.search ||
                                this.state.selectedTags?.length > 0) && (
                                <span className="heading d-block">
                                  No Reports Found.
                                </span>
                              )}
                            {this.state.ispermissionloaded &&
                              this.state.reportPermissions.length === 0 && (
                                <>
                                  <span className="heading d-block">
                                    No Report Permission
                                  </span>
                                  <span className="para d-block">
                                    You do not have any report permission.
                                  </span>
                                </>
                              )}
                          </span>
                        </div>
                      )}

                      {filteredData.map(
                        (item) =>
                          (item.parentId === 0 ||
                            item.parentId === null ||
                            this.state.showVarient === false ||
                            this.state.breadCrumps.length > 0) && (
                            <li key={item.moduleReportId}>
                              <div className="report-block">
                                <div className="report-block-body d-flex">
                                  <div className="sec-left">
                                    <div className="report-name">
                                      <EllipsisWithTooltip placement="bottom">
                                        {item.reportName}
                                      </EllipsisWithTooltip>
                                    </div>
                                    {/* <EllipsisWithTooltip placement="bottom"> */}
                                    <div className="report-description">
                                      {item.description.length >= 85 && (
                                        <OverlayTrigger
                                          placement="bottom"
                                          delay={{ show: 250, hide: 400 }}
                                          overlay={
                                            <Tooltip id={"reportdescription"}>
                                              {item.description}
                                            </Tooltip>
                                          }
                                        >
                                          <span>
                                            {item.description.slice(0, 85) +
                                              "..."}
                                          </span>
                                        </OverlayTrigger>
                                      )}

                                      {item.description.length < 85 && (
                                        <>{item.description}</>
                                      )}
                                    </div>
                                    <div className="d-flex">
                                      {this.getReportTags(item.reportTag)}
                                      {this.getAllReportTags(item.reportTag)}
                                    </div>
                                  </div>
                                  <div
                                    className="sec-right"
                                    onClick={() => this.openMediaViewer(item)}
                                  >
                                    <div className="report-preview">
                                      <div className="report-preview-overlay">
                                        <svg
                                          width="26"
                                          height="26"
                                          viewBox="0 0 26 26"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g filter="url(#filter0_d)">
                                            <path
                                              d="M22 16.344L19.879 18.465L16.707 15.293L15.293 16.707L18.465 19.879L16.344 22H22V16.344ZM4 9.656L6.121 7.535L9.293 10.707L10.707 9.293L7.535 6.121L9.656 4H4V9.656ZM22 4H16.344L18.465 6.121L15.293 9.293L16.707 10.707L19.879 7.535L22 9.656V4ZM4 22H9.656L7.535 19.879L10.707 16.707L9.293 15.293L6.121 18.465L4 16.344V22Z"
                                              fill="white"
                                            />
                                          </g>
                                          <defs>
                                            <filter
                                              id="filter0_d"
                                              x="-3"
                                              y="-3"
                                              width="32"
                                              height="32"
                                              filterUnits="userSpaceOnUse"
                                              color-interpolation-filters="sRGB"
                                            >
                                              <feFlood
                                                flood-opacity="0"
                                                result="BackgroundImageFix"
                                              />
                                              <feColorMatrix
                                                in="SourceAlpha"
                                                type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                              />
                                              <feOffset />
                                              <feGaussianBlur stdDeviation="2" />
                                              <feColorMatrix
                                                type="matrix"
                                                values="0 0 0 0 0.172549 0 0 0 0 0.243137 0 0 0 0 0.345098 0 0 0 0.08 0"
                                              />
                                              <feBlend
                                                mode="normal"
                                                in2="BackgroundImageFix"
                                                result="effect1_dropShadow"
                                              />
                                              <feBlend
                                                mode="normal"
                                                in="SourceGraphic"
                                                in2="effect1_dropShadow"
                                                result="shape"
                                              />
                                            </filter>
                                          </defs>
                                        </svg>
                                      </div>
                                      {item.reportImages.length > 0 ? (
                                        <MyImage
                                          width={100}
                                          height={120}
                                          src={
                                            item.reportImages[0]?.thumbnailPath
                                          }
                                          fallbackSrc={
                                            item.reportImages[0]?.thumbnailPath
                                          }
                                        ></MyImage>
                                      ) : (
                                        <MyImage
                                          width={100}
                                          height={120}
                                          src={reportPreview}
                                          fallbackSrc={reportPreview}
                                        ></MyImage>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                <div className="report-block-footer d-flex">
                                  {this.getVarientCount(item.moduleReportId) >
                                    0 &&
                                    this.state.showVarient === true && (
                                      <>
                                        <div className="variant-num d-flex align-items-center">
                                          <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M16.6667 4.16667H9.51175L8.08925 2.74417C7.93341 2.5875 7.72091 2.5 7.50008 2.5H3.33341C2.41425 2.5 1.66675 3.2475 1.66675 4.16667V15.8333C1.66675 16.7525 2.41425 17.5 3.33341 17.5H16.6667C17.5859 17.5 18.3334 16.7525 18.3334 15.8333V5.83333C18.3334 4.91417 17.5859 4.16667 16.6667 4.16667ZM3.33341 15.8333V5.83333H9.16675H10.0001H16.6667L16.6684 15.8333H3.33341Z"
                                              fill="#3F4347"
                                            />
                                          </svg>
                                          {this.getVarientCount(
                                            item.moduleReportId
                                          )}{" "}
                                          Versions
                                        </div>
                                        <Button
                                          className="expand-variants-btn btn-outline-primary ml-auto"
                                          onClick={(e) =>
                                            this.getReportVarients(
                                              item.moduleReportId,
                                              item.reportName
                                            )
                                          }
                                        >
                                          Expand Versions
                                        </Button>
                                      </>
                                    )}
                                  {(this.getVarientCount(
                                    item.moduleReportId
                                  ) === 0 ||
                                    this.state.showVarient === false) && (
                                      <>
                                        <span data-tip={tooltipMessageAdd}>
                                          <ReactTooltip
                                            effect="solid"
                                            event="mouseover mouseenter"
                                            eventOff="mouseleave mouseout scroll mousewheel blur"
                                            place="bottom"
                                            multiline={true}
                                          />
                                          <Button
                                            onClick={(e) =>
                                              this.openSaveReportModal(item)
                                            }
                                            className="cancel-btn btn-ghost ml-auto"
                                            disabled={
                                              item?.payrollSubscriptionRequired &&
                                              +item?.payrollIntegratedHotelsCount ===
                                              0
                                            }
                                          >
                                            Add
                                          </Button>
                                        </span>

                                        <>
                                          {item?.payrollSubscriptionRequired &&
                                            +item?.payrollIntegratedHotelsCount ===
                                            0 ? (
                                            <span
                                              data-tip={
                                                "Inn-Flow Payroll Subscription required to run this report"
                                              }
                                            >
                                              <ReactTooltip
                                                effect="solid"
                                                event="mouseover mouseenter"
                                                eventOff="mouseleave mouseout scroll mousewheel blur"
                                                place="bottom"
                                                multiline={true}
                                              />
                                              <Button
                                                className="reset-password-btn btn-outline-primary"
                                                disabled={true}
                                              >
                                                Run Report
                                              </Button>
                                            </span>
                                          ) : (
                                            <Button
                                              className="reset-password-btn btn-outline-primary"
                                              onClick={(e) =>
                                                this.openReportViewer(e, item)
                                              }
                                            >
                                              Run Report
                                            </Button>
                                          )}
                                        </>
                                      </>
                                    )}
                                </div>
                              </div>
                            </li>
                          )
                      )}
                    </ul>
                  </div>
                </>
              )}
            </div>
          </Modal.Body>
        </Modal>
        <div>
          {/* <ToastContainer
            enableMultiContainer
            autoClose={3000}
            containerId={"reportGallerySelection"}
          /> */}
          {this.state.showRenameModal && (
            <Modal
              className="rename-report-modal"
              show={this.state.showRenameModal}
              onHide={this.hideRenameModal}
              aria-labelledby="contained-modal-title-vcenter"
              centered
              keyboard={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>Report Name</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                This will be the name that appears in My Reports
                <input
                  type="text"
                  value={this.state.newReportName}
                  onChange={(e) => this.changeReportName(e)}
                  className="form-control"
                ></input>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="cancel-btn btn-ghost ml-auto"
                  onClick={this.hideRenameModal}
                >
                  Cancel
                </Button>
                <Button
                  disabled={this.state.disableSave}
                  className="reset-password-btn"
                  onClick={this.saveReport}
                >
                  Save
                </Button>
              </Modal.Footer>
            </Modal>
          )}
          <Modal
            show={this.state.showMediaViewer}
            keyboard={false}
            onHide={() => this.hideMediaViewerModal()}
            className="reports-screenshots-display-modal"
          >
            <Modal.Header closeButton>
              <Modal.Title className="mr-auto">
                {this.state.mediaViewerTitle}{" "}
                <div className="title-paging">
                  Page 1 of {this.state.reportImages?.length}
                </div>
              </Modal.Title>
              <div className="thumbnails d-flex">
                {this.state.reportImages?.map((image) => (
                  <div
                    className={
                      this.state.reportpreviewUrl === image.id
                        ? "report-img d-flex align-items-center justify-content-center active"
                        : "report-img d-flex align-items-center justify-content-center"
                    }
                    onClick={() => {
                      this.setState({
                        reportpreviewUrl: image.id,
                        currentImage: image,
                      });
                    }}
                  >
                    <MyImage
                      width={58}
                      height={58}
                      src={image.thumbnailPath}
                      fallbackSrc={image.thumbnailPath}
                    ></MyImage>
                  </div>
                ))}
              </div>
            </Modal.Header>
            <Modal.Body>
              <div className="main-Page reports-container d-flex justify-content-center">
                <div className="">
                  {this.state.reportImages?.map((image) => {
                    return (
                      this.state.reportpreviewUrl === image.id && (
                        <MyImage
                          width={665}
                          src={image.imagePath}
                          fallbackSrc={image.imagePath}
                        ></MyImage>
                      )
                    );
                  })}
                </div>
                <div className="back-next-arrows">
                  <Button
                    className="back-btn btn-outline-primary"
                    onClick={() => {
                      const previousIndex =
                        this.state.reportImages.findIndex(
                          (r) => +r.id === +this.state.currentImage.id
                        ) - 1;
                      if (previousIndex >= 0) {
                        this.setState({
                          reportpreviewUrl:
                            this.state.reportImages[previousIndex]?.id,
                          currentImage: this.state.reportImages[previousIndex],
                        });
                      }
                    }}
                  >
                    ‹
                  </Button>
                  <Button
                    className="back-btn btn-outline-primary"
                    onClick={() => {
                      const nextIndex =
                        this.state.reportImages.findIndex(
                          (r) => +r.id === +this.state.currentImage.id
                        ) + 1;
                      if (nextIndex <= this.state.reportImages.length - 1) {
                        this.setState({
                          reportpreviewUrl:
                            this.state.reportImages[nextIndex]?.id,
                          currentImage: this.state.reportImages[nextIndex],
                        });
                      }
                    }}
                  >
                    ›
                  </Button>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </>
    );
  }
}
